import { createTheme, Theme } from '@mui/material/styles';
import { BrandThemeConfig, getPalette } from './palette';
import { typography } from './typography';
import { components } from './components';
import { sharedVariables } from './variables';

export const createAppTheme = (mode: 'light' | 'dark', config: BrandThemeConfig | null): Theme => {
  return createTheme({
    palette: getPalette(mode, config),
    typography,
    spacing: sharedVariables.spacingUnit,
    shape: {
      borderRadius: sharedVariables.borderRadius,
    },
    components,
  });
};